import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.scss";
import "../../style.scss";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { MAIN } from "constants/route";
import { Modal } from "react-bootstrap";
import {XLANDING} from "constants/route";

import Footer from "./Footer";
import Header from "./Header";
import SubHeader from "./SubHeader";
import SubHeader2 from "./SubHeader2";

const log = (...args) => {
  console.log("idle", ...args);
}

const useIdleTimeout = ({idleExpirySec,idleExpiryWarningSec, onWarning, onTimeout}) => {
    const [_timeout, _setTimeout] = useState(null);
    const [_timeoutWarning, _setTimeoutWarning] = useState(null);
    
    // const [hasChanges, setHasChanges] = useState(false);
    // useEffect(() => {
    // }, [hasChanges]);
 
    useEffect(() => {
      return () => {
        log("cleanup");
        _timeout && clearTimeout(_timeout);
        _timeoutWarning && clearTimeout(_timeoutWarning);
      }
    }, [_timeout, _timeoutWarning]);

    // log("useIdleTimeout init", {idleExpirySec,idleExpiryWarningSec});
    const _clearTimeout = () => {
      log("_clearTimeout");
      if (_timeout) {
        clearTimeout(_timeout);
        _setTimeout(null);
      }
      if (_timeoutWarning) {
        clearTimeout(_timeoutWarning);
        _setTimeoutWarning(null);
      }
    }

    const _startTimeout = () => {
      log("_startTimeout");
      _setTimeout(setTimeout(() => {
        log("timeout");
        onTimeout && onTimeout();
      }, idleExpirySec));
    }

    const _startWarning = () => {
      log("_startWarning");
      _setTimeoutWarning(setTimeout(() => {
        log("warning");
        onWarning && onWarning();
      }, idleExpiryWarningSec));
    }

    return {
      startIdleTimer: () => {
        log("startIdleTimer");
        _clearTimeout();
        _startTimeout();
        _startWarning();
      },
      stopIdleTimer: () => {
        log("stopIdleTimer");
        _clearTimeout();
      }
    }
}

const TimeoutModal = ({ show, logout, continueSession }) => {
  const isMobile = window.innerWidth < 768;

  return <Modal show={show}>
      <Modal.Header className="bg-button-color" closeButton={false} />
      <Modal.Body className="p-3">
              {/* <div className={"text-center"}>
                <i
                  className={`icon-dls-warning-solid icon-big`}
                  style={{ color: "#a46200", fontSize: 80 }}
                  aria-hidden="true"></i>
                {error}
              </div> */}
        <div className="cmp-modal__content text-center" style={{color:"#134f4e"}} >
          <div className="cmp-modal__icon">
            <span className="icon-dls-warning-solid"
                      style={{ color: "#b7760d", fontSize: 80 }}
            ></span>
          </div>
          <div>
            <h4 className="title__text title__text--semi-bold" style={{paddingBottom: 16}}>
              Your session is about to time out.
            </h4>
            <p className="cmp-modal__content--cta" style={{fontWeight:600}}>
              You have been inactive for a while. Would you like to log out or continue?
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <div className="cmp-modal__cta logout-button-layout-mobile">
          <button className="cmp-button cmp-button--secondary cmp-button--cancel" onClick={logout}>
            <span className="cmp-button__text"> Log out </span>
          </button>
          { !isMobile ? <>&nbsp;&nbsp;&nbsp;</> : <></> }
          <button className="cmp-button cmp-button--primary cmp-button--ok" onClick={continueSession}>
            <span className="cmp-button__text"> Continue </span>
          </button>
        </div>
     </Modal.Footer>
   </Modal>
}


export default function Layout(props) {
  const [showIdleTimeoutModal, setShowIdleTimeoutModal] = React.useState(false);
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const { pathname } = useLocation();
  const {
    heightAdjust = true,
    animated = true,
    subHeader = null,
    mainText = null,
    loginRequired = true,
    noSubHeaderMainText = false
  } = props;

  const { isOpenedSideBar } = useSelector((state) => state.header);

  const onIdleWarning = () => {
    setShowIdleTimeoutModal(true);
  }

  const onIdleTimeout = () => {
    setShowIdleTimeoutModal(false);
    idleLogout();
  }


  const { startIdleTimer, stopIdleTimer } = useIdleTimeout({  
    idleExpirySec: window.idleExpirySec, 
    // idleExpirySec: 3 * 60 * 1000,
    idleExpiryWarningSec: window.idleExpiryWarningSec,
    onWarning: onIdleWarning,
    onTimeout: onIdleTimeout,
  });


  const isMainService = pathname === MAIN;

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(()=>{
     if(pathname === XLANDING) {
       stopIdleTimer();
     } else {
       startIdleTimer();
     }
     return () =>{
       stopIdleTimer();
     }
  }, [pathname]);

  const logout = () => {
    if (window.appMode === "DEV") {
      alert("Please click logout manually. This is a DEV environment.");
      navigate(XLANDING);
    } else {
      // UAT or PROD
      window.location.href = window.mainLogoutUrl;
    }
  };


  console.log("isOpenedSideBar", isOpenedSideBar, heightAdjust);

  // If user is act as clicking logout button.
  // If not, recirect to home, XLANDING
  const idleLogout = () => {
    if (isLogin) {
      logout();
    } else {
      navigate(XLANDING);
    }
  }

  return (
    <>
      <Header loginRequired={loginRequired} />
      {isMainService ? (
        <SubHeader />
      ) : (
        <SubHeader2
          noSubHeaderMainText={noSubHeaderMainText}
          header={subHeader}
          mainText={mainText}
        />
      )}
      {!isOpenedSideBar && (
        <>
          <div className={`container-parent`} style={{ paddingBottom: 20 }}>
            {heightAdjust ? (
              <div
                className={`container wrap-container   ${
                  animated && "animate__animated animate__bounceInRight"
                }`}>
                <div className="row h-100 height-adj" style={{ paddingBottom: 50 }}>
                  <div className="col-sm-12 my-auto">
                    <div className="mx-auto">{props.children}</div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`container ${animated && "animate__animated animate__bounceInRight"}`}>
                <div className="mx-auto">{props.children}</div>
              </div>
            )}
          </div>
          <Footer />
        </>
      )}
      <TimeoutModal show={showIdleTimeoutModal} 
        logout={onIdleTimeout} 
        continueSession={()=>{
          setShowIdleTimeoutModal(false);
          startIdleTimer();
        }}/>
    </>
  );
}
